// extracted by mini-css-extract-plugin
export var logo = "_k6-2";
export var logoWrapper = "_k6-1";
export var strip = "_k6-0";